export const formatSafeValue = (value: unknown, fallback = 'N/A'): string => {
  if (value === null || value === undefined || value === '') {
    return fallback;
  }

  return String(value);
};
